(ns minorodata.connections.sources.amplitude
  (:require [minorodata.app.utils :as app.utils]))


(def source
  {:id           "amplitude"
   :enabled      true
   :name         "Amplitude"
   :image-source "amplitude.svg"
   :description  "Product Intelligence platform helping companies build better products"
   :tags         ["analytics"]
   :message-queue-enabled true

   :preview-formatter
   (fn [source]
     (str "Username: " (get-in source [:credentials :username])))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description username password region]} data]
        {:source-type "amplitude"
         :name        name
         :description description

         :source
         {:region      region
          :credentials {:type     "account-credentials"
                        :username username
                        :password password}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials region]} source]
        (merge {:name        name
                :description description
                :region      region}
               (select-keys credentials [:username :password]))))

    :validate (constantly nil)

    :id :amplitude-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :input
              :label      "Username"
              :name       :username
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Password"
              :name       :password
              :type       :password
              :required   true
              :value      ""}

             {:block-type :select
              :label      "Region"
              :name       :region
              :options    [{:name "Standard Server"     :value "standard"}
                           {:name "EU Residency Server" :value "eu-residency"}]
              :required   true
              :value      "standard"}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table extract-type event-types]}]
      {:name          name
       :description   (or description "")
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action            action
                    :destination-table destination-table
                    :report            "export"
                    :extract-type      extract-type
                    ;; hidden blocks still reach format-for-api, so only send the
                    ;; event types when the filtered extract type is selected
                    :event-types       (when (= "incremental-filtered" extract-type)
                                         event-types)}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:action :destination-table :extract-type :event-types])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :amplitude-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}


             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Incremental (data since last extract was run)" :value "incremental"}
                           {:name "Incremental, filtered by event type"           :value "incremental-filtered"}]
              :required   true
              :value      "incremental"}

             {:block-type  :input
              :label       "Event Types"
              :name        :event-types
              :required    true
              :value       ""
              :placeholder "Value 1,Value 2,Value 3"
              :conditions  [[:eq [:extract-type :value] "incremental-filtered"]]}

             {:content    (str "Comma separated list of EVENT_TYPE values to keep. Matching is exact and "
                               "case sensitive; every other event is discarded before it reaches the "
                               "warehouse. Note this filters the EVENT_TYPE column, not AMPLITUDE_EVENT_TYPE.")
              :conditions [[:eq [:extract-type :value] "incremental-filtered"]]}


             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
